const Divider = () => {
  return (
    <div 
      className="divider" 
      style={{
        height: '100px',
        width: '100%',
        backgroundColor: 'black',
        position: 'relative',
        marginTop: '-25px',
        marginBottom: '-25px',
        left: 0,
        right: 0,
        zIndex: 0
      }}
    ></div>
  );
};

export default Divider;
